export default {
  prepend(h, conf, key) {
    return <template slot='prepend'>{conf.bpmSlot[key]}</template>
  },
  append(h, conf, key) {
    return <template slot='append'>{conf.bpmSlot[key]}</template>
  }
}
